export default function CFunctions() {
  return <h2>C Functions</h2>;
}
